// `ledger` va `audit` endpointlari `total` QAYTARMAYDI, faqat `hasNext`
// (koordinator tuzatishi — ilgari `total` bor deb taxmin qilingan edi).
//
// `DataTable` esa `PageResult<T> = {items, total}` shaklini kutadi, chunki
// antd `Pagination` sahifalar sonini `total`dan hisoblaydi. Ikkalasini
// yarashtirish uchun SUN'IY (lekin TO'G'RI ISHLAYDIGAN) `total` yasaladi:
//
//   · `hasNext` bo'lsa   → keyingi sahifa "bor" deb ko'rsatiladigan minimal son
//   · `hasNext` bo'lmasa → aniq son (joriy sahifagacha + shu sahifadagi qatorlar)
//
// `DataTable`da `showTotal={false}` berilishi SHART — aks holda "1–25 / 26"
// kabi YOLG'ON aniq son ko'rsatilardi, sahifalash tugmalari esa baribir
// to'g'ri ishlaydi (faqat "jami necha" yozuvi yashiriladi).

/**
 * @param page1Based UI'dagi sahifa raqami (1 dan boshlanadi)
 */
export function syntheticTotal(page1Based: number, pageSize: number, rowCount: number, hasNext: boolean): number {
  const countedSoFar = (page1Based - 1) * pageSize + rowCount
  return hasNext ? countedSoFar + 1 : countedSoFar
}
